import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://dominandoshopify.impultienda.ar/';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eA7mtCbRQrGw8Qn2PutU2F/WhatsApp_Image_2026-05-03_at_07.20.44.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/wL6aGDqFb48777ZA8eDtJx/WhatsApp_Image_2026-05-03_at_06.59.12.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const beforeImages = ['https://cdn.magicpatterns.com/uploads/befWjZNtk1Kzw6ruZphVyD/WhatsApp_Image_2026-05-02_at_22.08.03_(2).jpg', 'https://cdn.magicpatterns.com/uploads/g1egev8N4akbkZNtXocYzF/WhatsApp_Image_2026-05-02_at_22.08.03.jpg', 'https://cdn.magicpatterns.com/uploads/2K1CzXbcjYAezJTLa9sUSn/WhatsApp_Image_2026-05-02_at_22.15.42_(1).jpg'];
const lifeImages = ['https://cdn.magicpatterns.com/uploads/fQpJkUjt1R3RWzkwYt6DaD/WhatsApp_Image_2026-05-02_at_22.20.20.jpg', 'https://cdn.magicpatterns.com/uploads/nTYCMskRwtN3osvAAzwFK9/WhatsApp_Image_2026-05-02_at_22.58.39.jpg', 'https://cdn.magicpatterns.com/uploads/83qTWzNa1nqYosmjdMaVi9/WhatsApp_Image_2026-05-02_at_23.53.22_(1).jpg', 'https://cdn.magicpatterns.com/uploads/iKzX9YnRdfca4AtUQnuC7g/IMG_7620.jpg', 'https://cdn.magicpatterns.com/uploads/7pByoThoZobCp5UhEwvcCv/WhatsApp_Image_2026-05-02_at_22.17.47.jpg', 'https://cdn.magicpatterns.com/uploads/asz4YqNpKLw8V6zPXc73Lu/WhatsApp_Image_2026-05-03_at_00.02.17.jpg', 'https://cdn.magicpatterns.com/uploads/g7jZp64b5GLUsbZUNNBYAU/IMG_7698.jpg', 'https://cdn.magicpatterns.com/uploads/6CHYXvBen1tpaSGGrt4EXT/WhatsApp_Image_2026-05-02_at_22.08.03_(3).jpg', 'https://cdn.magicpatterns.com/uploads/gQPiCcLr1e4JCbD6QFhttA/WhatsApp_Image_2026-05-03_at_00.00.02.jpg', 'https://cdn.magicpatterns.com/uploads/wjdE8UQBY1NPoYxHp531V2/WhatsApp_Image_2026-05-03_at_00.05.58.jpg'];
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [beforeSlide, setBeforeSlide] = useState(0);
  const [lifeSlide, setLifeSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBeforeSlide(prev => (prev + 1) % beforeImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setLifeSlide(prev => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const goTo = (index: number) => setCurrentSlide(index);
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % resultImages.length);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = [{
    emoji: '❌',
    before: 'Ves cómo todos venden por internet pero ',
    bold: 'no sabés cómo empezar',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Ganas menos de $3.000 usd y ',
    bold: 'no te alcanza?',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Estas atrapado en una rutina que no te llena y ',
    bold: 'no sabes como salir de ahi...',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Compraste MIL cursos/mentorías y seguís ',
    bold: 'FRUSTRADO/A sin lograr vivir de internet?',
    after: '💰💻'
  }, {
    emoji: '❌',
    before: '¿Te cuesta avanzar SOLO/A y necesitas ',
    bold: 'acompañamiento REAL en VIVO?',
    after: ''
  }];
  return <section className="py-6 md:py-10 px-4 pt-[0px] pb-[0px] bg-[#2F0240]" data-id="element-142" data-mp="2l1w6wnfzu34t">
      <div className="max-w-6xl mx-auto" data-id="element-143" data-mp="2q20lg7xccnse">
        <div className="text-center mb-8" data-id="element-144" data-mp="2q31vqa6j9692">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-[0_0_15px_rgba(34,197,94,0.5)] animate-glow-badge pt-[6px] pb-[6px] mt-[10px] mb-[10px] bg-[#9C16A3]" data-id="element-145" data-mp="2c2isrhgxcqdr">
            <span data-id="element-146" data-mp="34rgb1kl4yn6i"></span>
            <span data-id="element-147" data-mp="34t0vuihnerr6">💰DOMINANDO SHOPIFY💰</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight max-w-5xl mx-auto uppercase text-[#FFFFFF]" data-id="element-148" data-mp="38rqg8v13t9kb">
            CREÁ Y VENDÉ TU PRIMER{' '}
            <span className="text-[#FC9DFF] bg-[2F0240]" data-id="element-149" data-mp="2zzept95zpm4c">EBOOK</span> EN{' '}
            <span className="text-[#FC9DFF]" data-id="element-150" data-mp="3npiuljuwzrwx">72 HS</span> Y GENERÁ{' '}
            <span className="underline decoration-4 decoration-yellow-400 text-[#FC9DFF]" data-id="element-151" data-mp="3no7pngpqge48">
              $100 A $300 USD DIARIOS
            </span>{' '}
            EN <span className="text-[#FC9DFF]" data-id="element-152" data-mp="5ovcofyo54jg">AUTOMÁTICO</span>
          </h2>

          <div className="flex justify-center mb-8" data-id="element-153" data-mp="1o1rvvgiw5us">
            <div className="w-full max-w-lg aspect-video overflow-hidden rounded-lg shadow-2xl mt-[-20px] mb-[-20px] bg-black" data-id="element-154" data-mp="1njvmytv1rmv">
              <iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1954979904990290%2F&show_text=false&width=560&t=0" title="Video de presentación de Dominando Shopify" className="w-full h-full border-0" scrolling="no" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen data-id="element-155" data-mp="fhavtglpbz5x" />
            </div>
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto text-[#FACC15] text-[14px] pt-[0px] pb-[0px] mt-[30px] mb-[30px]" data-id="element-156" data-mp="183vn6h26gb9h">
            ⭐+500 Alumnos ⚡Acceso inmediato 🛡️ Garantía 7 días 🔒 Pago seguro
            💳 Mercado Pago
          </p>

          <div className="rounded-xl p-6 mb-8 max-w-3xl mx-auto bg-[#9C16A3] animate-neon-violet" data-id="element-157" data-mp="1b4ytceyufivi">
            <p className="md:text-xl font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[16.5px]" data-id="element-158" data-mp="1f5r0n2o5ndp5">
              Ganamos💰+$70 Millones en los últimos 6 meses → y te enseñamos el
              PASO a PASO ✅ Desde CERO ✅ Sin Experiencia ✅ Sin mostrarte en
              cámara✅
            </p>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-159" data-mp="rfobaubmklu8"></p>
        </div>

        <div className="text-center mt-[-10px] mb-[-10px]" data-id="element-160" data-mp="whdreodpfpp6">
          <CTAButton text="QUIERO ACCEDER AHORA👉🏻" href={CHECKOUT_URL} size="large" className="w-full md:w-auto text-2xl animate-pulse-green" data-id="element-161" data-mp="11fnk8sbyie7m" />
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-162" data-mp="8qgn9xs5hwoh">
          <h3 className="text-2xl md:text-3xl font-black text-center uppercase text-[#FFFFFF] mt-[20px] mb-[20px]" data-id="element-163" data-mp="dqcrny4rfq4k">
            Nuestros Resultados👇
          </h3>
          <div className="relative" data-id="element-164" data-mp="66bngwahdxqa">
            <div className="overflow-hidden rounded-2xl border-2 border-[#FC9DFF] shadow-xl" data-id="element-165" data-mp="17qu9gtncebc">
              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-166" data-mp="3se1rt2zg6wxx">
                {resultImages.map((img, index) => <img key={index} src={img} alt={`Resultado ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-167" data-mp="3jfgdxl4x863h" data-mpi={index} />)}
              </div>
            </div>

            <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-168" data-mp="2zp4lly8igqlj">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-169" data-mp="nejl5bzbslvv" />
            </button>
            <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-170" data-mp="nd8ijfhm9k6c">
              <ChevronRightIcon className="w-5 h-5" data-id="element-171" data-mp="ifzwh3tckvzt" />
            </button>

            <div className="flex justify-center gap-2 mt-4" data-id="element-172" data-mp="ii2y6l3v4dkd">
              {resultImages.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-173" data-mp="4mqpf9svgmkg" data-mpi={index} />)}
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-8 md:p-10 mb-10 max-w-3xl mx-auto bg-[#3E0400]" data-id="element-174" data-mp="3huv8z0d8pzya">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-8 text-center" data-id="element-175" data-mp="3lx8b7ess3fqb">
            ¿TE IDENTIFICAS?
          </h3>
          <div className="space-y-4" data-id="element-176" data-mp="3397mv9nh8lcs">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 border border-amber-600/40 rounded-xl px-5 py-4 bg-gray-900/60" data-id="element-177" data-mp="2yad4u9xc30tq" data-mpi={index}>
                <span className="text-2xl flex-shrink-0 bg-gray-800 rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-178" data-mp="379i2le12mq4u">
                  {point.emoji}
                </span>
                <p className="text-base md:text-lg font-medium text-[#FFFFFF]" data-id="element-179" data-mp="3h879ycvccs6u">
                  {point.before}
                  <span className="font-bold text-[#FC9DFF]" data-id="element-180" data-mp="3v03yy81pqlz0">{point.bold}</span>
                  {point.after}
                </p>
              </div>)}
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center" data-id="element-181" data-mp="8s4dl39oipxt">
          <p className="md:text-xl mb-3 font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[20px]" data-id="element-182" data-mp="8snoi00wwe2c">
            Te entendemos... Nosotros también estuvimos ahí...💔
          </p>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-183" data-mp="2qupr93byck4b">
          <div className="relative" data-id="element-184" data-mp="2m1muynfsiwkf">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-185" data-mp="2m0ljihuv4826">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${beforeSlide * 100}%)`
            }} data-id="element-186" data-mp="2i1cqjf7nce7o">
                {beforeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida antes ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-square" data-id="element-187" data-mp="35pcgwe11q2lq" data-mpi={index} />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-188" data-mp="1pcf89c3fqhex">
              {beforeImages.map((_, index) => <button key={index} onClick={() => setBeforeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${beforeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-189" data-mp="1kb80hd1ali89" data-mpi={index} />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 px-2 text-[17px] font-[Montserrat,_sans-serif] font-[500]" data-id="element-190" data-mp="1oxierycvncaq">
            Esta era nuestra vida antes: de casa al trabajo, del trabajo a casa.
            Sin tiempo... Sin dinero...estresados, endeudados y frustrados.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-10" data-id="element-191" data-mp="22xjg1ex20lqq">
          <h3 className="text-2xl md:text-4xl font-black text-[#FACC15] leading-tight" data-id="element-192" data-mp="22v6wixbne3bk">
            Y gracias a vender productos digitales...
          </h3>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-193" data-mp="8kk1lp4etxl1">
          <div className="relative" data-id="element-194" data-mp="dibscftbjdnn">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-195" data-mp="djd64s1pye92">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${lifeSlide * 100}%)`
            }} data-id="element-196" data-mp="5hdx8jwftqj7">
                {lifeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida ahora ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-197" data-mp="fdh1bvaunz8s" data-mpi={index} />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-198" data-mp="y6uqtkvsndh0">
              {lifeImages.map((_, index) => <button key={index} onClick={() => setLifeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${lifeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-199" data-mp="t89mpadf89na" data-mpi={index} />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-200" data-mp="1luhrlx93nk2a">
            ❤️Nuestras vidas cambiaron❤️Hoy tenemos paz mental, libertad,
            tiempo, dinero y muchos viajes.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-12" data-id="element-201" data-mp="1hr1yhaw8o1uc">
          <h3 className="md:text-4xl mb-4 text-[20px] font-[700] font-[Montserrat,_sans-serif] text-[#FC9DFF]" data-id="element-202" data-mp="133gttcjptukb">
            Y vos también podes mejorar tu estilo de vida...
          </h3>
          <p className="text-xl md:text-2xl font-semibold text-white font-[Montserrat,_sans-serif]" data-id="element-203" data-mp="u2iq6vd6vp29">
            Es por eso que creamos el Programa{' '}
            <span className="text-[#FC9DFF] font-black" data-id="element-204" data-mp="y4x4r39ts2nq">DOMINANDO SHOPIFY</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-205" data-mp="k4uspxo783ge">
          <img src="https://cdn.magicpatterns.com/uploads/fcRwvhZ941oy9wboiX5iMk/mockup_dominando_shopify.png" alt="Programa Dominando Shopify - Mockup" loading="lazy" className="w-full rounded-2xl shadow-2xl" data-id="element-206" data-mp="p362y9ieofz5" />
          <p className="text-center md:text-lg text-gray-200 mt-6 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-207" data-mp="1nhcxrk8i5k8y">
            📚 Donde te enseñamos paso a paso a crear, lanzar y escalar tu
            tienda online con Shopify + Meta Ads desde cero.
          </p>
        </div>
      </div>
    </section>;
}